import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { AlertCircle, ArrowLeft } from "lucide-react";

export const DirectoryNoIdAlert = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="p-4">
      <Alert variant="destructive">
        <AlertCircle className="h-4 w-4" />
        <AlertTitle>{t("common.error")}</AlertTitle>
        <AlertDescription>{t("common.noIdProvided")}</AlertDescription>
      </Alert>
      <Button
        variant="ghost"
        size="sm"
        onClick={() => navigate(-1)}
        className="mt-4"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        {t("common.back")}
      </Button>
    </div>
  );
};
